import { Input, Popover } from '@chakra-ui/react';
import { ChangeEvent } from 'react';

import { useFilterState } from '../../hooks/useFilterState';
import { FilterPopoverButton, FilterPopoverContent } from '../FilterPopoverButton';

type Props = {
  value: string;
  onChange: (value: string) => void;
};

export const StringFilterPopover = ({ value, onChange }: Props) => {
  const state = useFilterState({
    defaultValue: value,
    onSubmit: onChange,
  });

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const nextValue = event.target.value;
    onChange(nextValue);
    state.onChange(nextValue);
  };

  return (
    <Popover placement="bottom-start">
      <FilterPopoverButton label={state.value} />
      <FilterPopoverContent onClickApply={state.onSubmit} onClickCancel={state.onReset}>
        <Input value={state.value} onChange={handleChange} />
      </FilterPopoverContent>
    </Popover>
  );
};
